import React, { Component } from "react";
import { connect } from "react-redux";
import { disablePriceAlert, getAirport, getPriceAlert } from "../shared/requests-api";
import moment from "moment";
import { $ } from "../shared/utils";
import PubSub from "pubsub-js";

class PriceAlertDisable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			alert: null
			// alert: {
			// 	from: "BHZ",
			// 	to: "SAO",
			// 	adults: 1,
			// 	infants: 0,
			// 	children: 0,
			// 	outboundDate: "2019-06-12",
			// 	inboundDate: "2019-06-18",
			// 	frequentFlyerId: "abcdefghijklmnopqrstuvxz0123456789"
			// }
		};

		this.disableAlert = this.disableAlert.bind(this);

		this.setAlertInfo();
	}

	setAlertInfo() {
		getPriceAlert(this.props.id)
			.then(response => {
				let alert = response.data;

				if (alert.status === "searching") {
					Promise.all([getAirport(alert.from), getAirport(alert.to)]).then(arr => {
						this.setState({
							alert: alert
						});
					});
				} else {
					this.goToHome();
				}
			})
			.catch(() => {
				this.goToHome();
			});
	}

	goToHome() {
		window.location.pathname = "/";
	}

	track(alert, reason) {
		let data = { ...alert };
		data.reason = reason;

		delete data.createDate;
		delete data.lastSent;

		PubSub.publish("dataLayer", {
			event: "ditoIdentifyEmail",
			ditoIdentify: {
				email: alert.userEmail
			}
		});

		PubSub.publish("dataLayer", {
			event: "ditoTrack",
			ditoTrack: {
				action: "desabilitou-alerta-de-preco",
				data: data
			}
		});
	}

	disableAlert() {
		let reason = "";
		const radios = document.getElementsByName("reason");
		for (let i = 0; i < radios.length; i++) {
			if (radios[i].checked) {
				reason = radios[i].value;
				break;
			}
		}

		if (reason !== "") {
			const $action = $(".price-alert-disable-form .actions");
			const $loading = $(".loading");

			$action.classList.add("hide");
			$loading.classList.remove("hide");

			disablePriceAlert(this.props.id, reason)
				.then(() => {
					this.track(this.state.alert, reason);

					$(".price-alert-disable-form").classList.add("hide");
					$(".price-alert-disable-success").classList.remove("hide");
				})
				.catch(() => {
					$action.classList.remove("hide");
					$loading.classList.add("hide");
				});
		}
	}

	render() {
		if (this.state.alert === null) {
			return <div />;
		}

		const radios = [
			{
				id: 'reason1',
				label: 'Já comprei minha passagem',
				value: 'comprei-passagem'
			},
			{
				id: 'reason2',
				label: 'Desisti da minha viagem',
				value: 'desisti'
			},
			{
				id: 'reason3',
				label: 'Estou recebendo muitos emails',
				value: 'emails'
			}
		]

		const ramdomRadios = radios.sort(() =>  0.5 - Math.random())

		const {outboundDate, inboundDate, to, from, frequentFlyerId} = this.state.alert

		const outbound = moment.utc(outboundDate);
		const inbound =
			inboundDate === null ? null : moment.utc(inboundDate);

		return (
			<div className="container">
				<div className="price-alert-disable">
					<div className="price-alert-disable-form">
						<div className="price-alert-disable-header">
							<div className="bell-wrapper">
								<i className="icon-bell" />
							</div>
							<h2>{frequentFlyerId ? "Ponte Aérea Max" : "Alerta de preço"}</h2>
							<p>
								<strong>Tem certeza de que deseja cancelar {frequentFlyerId ? "o aviso para esta data da viagem?" : "o alerta?"}</strong>
								<br/>
								{frequentFlyerId ? "Se cancelar essa opção, você deixará de receber e-mails com os melhores valores para esta data." : "Ao cancelar você vai deixar de receber emails com avisos sobre o valor da passagem para sua viagem."}
							</p>
						</div>
						<div className="price-alert-disable-content">
							<div className="box">
								<h3 className="flight-stretch">
									{from} - {to}
								</h3>
								<div className="flight-date">
									Ida - {outbound.format("DD/MM/YYYY")}
								</div>
								{inbound !== null && (
									<div className="flight-date">
										Volta - {inbound.format("DD/MM/YYYY")}
									</div>
								)}
							</div>
							<div className="options">
								<p className="text-center">
									<strong>{frequentFlyerId ? "Antes de ir, conta pra gente porque está desistindo desta data." : "Antes de ir, nos conte porque está cancelando o alerta:"}</strong>
								</p>
								<ul className="list-unstyled">
									{ramdomRadios.map((item, index) => (
										<li key={index} className="radio-wrapper">
											<input
												name="reason"
												type="radio"
												id={item.id}
												className="radio-wrapper--radio"
												value={item.value}
											/>
											<label htmlFor={item.id}>{item.label}</label>
										</li>
									))}
								</ul>
								<div className="actions">
									<button className="btn btn-default btn-keep" onClick={this.goToHome}>
										Manter {frequentFlyerId ? "esta data" : "este alerta"}
									</button>
									<button className="btn btn-default btn-disable" onClick={this.disableAlert}>
										Cancelar {frequentFlyerId ? "esta data" : "este alerta"}
									</button>
								</div>
								<div className="loading hide">
									<div className="loading-price-alert">
										<i className="loader loader-fetching" />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="price-alert-disable-success hide">
						<div className="price-alert-disable-header">
							<div className="bell-wrapper">
								<i className="icon-bell" />
							</div>
							<h2>{frequentFlyerId ? "Ponte Aérea Max" : "Alerta de preço"}</h2>
							<p className="lead hidden-xs">
								A gente continua aqui para te ajudar a viajar mais!
							</p>
							<p>
								Quer viajar em outra data? Busque outras passagens e crie alertas para viagens futuras.
							</p>
						</div>
						<div className="price-alert-disable-content">
							<button className="btn btn-success" onClick={this.goToHome}>
								Voltar para a home
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	id: ownProps.match.params.id
});

export default connect(mapStateToProps, () => ({}))(PriceAlertDisable);
